import { useLanguagePath } from "hooks/useLanguagePath";

interface ICustomWindowLocation {
  url: string;
  isExternal?: boolean;
  replace?: boolean;
}

/**
 * Custom window.location wrapper that handles language routing for internal links
 * @param url - The URL to navigate to
 * @param isExternal - If true, navigates to URL as-is without language prefix
 * @param replace - If true, uses location.replace instead of location.href (no history entry)
 */
const useCustomWindowLocation = () => {
  const { getLocalizedPath } = useLanguagePath();

  const customWindowLocation = ({
    url,
    isExternal = false,
    replace = false,
  }: ICustomWindowLocation): void => {
    if (!url) return;

    // Use URL as-is for external links
    const finalUrl = isExternal ? url : getLocalizedPath(url);

    if (replace) {
      window.location.replace(finalUrl);
    } else {
      window.location.href = finalUrl;
    }
  };

  return customWindowLocation;
};

export default useCustomWindowLocation;
